// extracted by mini-css-extract-plugin
export var dropdownButton = "_32-0";
export var fullWidthDropdownButton = "_32-1";
export var icon = "_32-3";
export var iconPlaceholder = "_32-2";
export var menuItemRow = "_32-9";
export var separator = "_32-e";
export var shortcutContainer = "_32-7";
export var shortcutContainerFilled = "_32-8";
export var shortcutIconLg = "_32-6";
export var shortcutIconMd = "_32-5";
export var shortcutIconSm = "_32-4";
export var submenuChevron = "_32-d";
export var submenuDropdown = "_32-a";
export var submenuTriggerRow = "_32-b";
export var submenuTriggerRowOpen = "_32-c";